const GameUtils = {
    dedupeArray: function(inputArray) {
        const outputArray = [];
        if (inputArray && Array.isArray(inputArray) && inputArray.length > 0) {
            inputArray.forEach(item => {
                const outputItem = outputArray.find(i => i.id === item.id);
                if (!outputItem) {
                    outputArray.push(item);
                }
            });
        }
        return outputArray;
    },
    randomInternal: function(range, staticItems = null) {
        // TODO: add entropy here.
        let randomNumber = Math.random();
        if (staticItems && staticItems.length) {
            let result = null;
            while (result === null) {
                const resultToCheck = Math.floor(randomNumber * range);
                if (!staticItems.includes(resultToCheck)) {
                    result = resultToCheck;
                } else {
                    randomNumber = Math.random();
                }
            }
            return result;
        } else {
            return Math.floor(randomNumber * range);
        }
    },
    createShuffledArrayInternal: function(srcCount, destCount = undefined, itemIndexesToNotShuffle = null) {
        let destArray = [];

        destCount = destCount ? destCount : srcCount;
        let remainder = (srcCount > destCount) ? 0 : destCount % srcCount;
        let tailoredDestCount = destCount - remainder;
        const replicateCount = tailoredDestCount / srcCount;

        for (let replicateIndex = 0; replicateIndex < replicateCount; replicateIndex++) {
            for (let index = 0; index < srcCount; index++) { destArray.push(index);}
        }
        for (let index = 0; index < remainder; index++) { destArray.push(index); }

        return this.shuffleArrayInternal(destArray, itemIndexesToNotShuffle);
    },
    shuffleArrayInternal: function(array, itemIndexesToNotShuffle = null) {
        // now shuffle by moving through the array exchanging random positions.
        array.forEach((value, index) => {
            if (itemIndexesToNotShuffle && itemIndexesToNotShuffle.length && itemIndexesToNotShuffle.includes(value)) {
                return;
            }
            const lotteryIndex = this.randomInternal(array.length, itemIndexesToNotShuffle);
            const lotteryValue = array[lotteryIndex];
            array[lotteryIndex] = value;  // do the switch
            array[index] = lotteryValue;
        });
        return array; // array has even distribution (end filled in sequence)
    },
    makeProperNoun: function (word) {
        return word.charAt(0).toUpperCase() + word.substring(1);
    },
    getOpponentComment: function (champStars, challengerStars) {
        const spread = champStars - challengerStars;
        let comment = 'Too close to call';
        const gotIt = ['You got this', ''];
        const trouble = ['This does not look good.', 'Looks like you might get schooled.']
        const even = ['Looks like this is will be close', 'Too close to call', 'Looks like a nail biter'];
        if (spread > 2) {
            return gotIt[GameUtils.randomInternal(gotIt.length)];
        } else if ( spread < - 2) {
            return trouble[GameUtils.randomInternal(trouble.length)];
        } else {
            return even[GameUtils.randomInternal(even.length)];
        }
    },
    getGameChallengeName: function(handle) {
        const parts = handle.split('-');
        return `${GameUtils.makeProperNoun(parts[2])} ${GameUtils.makeProperNoun(parts[3])} Challenge`;
    },
    getGameQuip: function (handle) {
        const parts = handle.split('-');
        const quips = [
            `Can you do '${parts[0]}'?`,
            `We looked in your pantry and we don't see ${parts[2]}.`,
            `We called your mom and she says you don't like ${parts[3]}`,
            `Your bio says ${parts[3]} is your guilty pleasure. Let's find out...`,
        ];
        const rndQuip = GameUtils.randomInternal(quips.length);
        return quips[rndQuip];
    },
    getTaunt: function(champPoints, challengerPoints, isPlayerChallenger) {
        const badLossTaunts = ['The kitchen called. It wants the spatula back.', 'Ah, check your drawers, I think you may have dropped something.', 'You call that food? The judges were not impressed.'];
        const narrowDefeatTaunts = ['A narrow defeat.', 'Close but no cigar', 'Not your best performance', 'You were unlucky', 'ooh, close, a little too much salt maybe? Just sayin\''];
        const narrowVictoryTaunts = ['You squeaked through!', 'Congrats, you won 2-1', 'A win is a win is a win and you won!', 'That\'s right, you ready!', 'You only need to win by one and that is exactly what you did.'];
        const crushedItTaunts = ['You crushed it.', 'Time to open your own metaKitchen', 'The real OG is in the house.', 'Feast on that!'];
        const playerIsWinner = (challengerPoints > champPoints && isPlayerChallenger) || (champPoints > challengerPoints && !isPlayerChallenger);
        const spread = Math.abs(champPoints - challengerPoints);
        const isClose = (spread === 1);
        let taunts = [];

        if (playerIsWinner) {
            if (isClose) {
                taunts = narrowVictoryTaunts;
            } else {
                taunts = crushedItTaunts
            }
        } else {
            if (isClose) {
                taunts = narrowDefeatTaunts;
            } else {
                taunts = badLossTaunts
            }
        }

        return taunts[GameUtils.randomInternal(taunts.length)]
    }
};
export default GameUtils;